export const prefecturesApiUrl = '/karte/api/v1/prefectures/';

export const getPrefectures = async () => {
  try {
    const response = await fetch(prefecturesApiUrl);
    if (!response.ok) {
      throw new Error(`Network response was not ok: ${response.statusText}`);
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('API fetch failed:', error);
    throw error;
  }
};

export const loadPrefectures = async (data: any) => {
  const prefecturesData: any = await Promise.all(
    data.results.map((prefecture: any) => {
      const prefecturesRecord: PrefecturesRecord = {
        id: prefecture.id,
        region_id: prefecture.region_id,
        region_name: prefecture.region_name,
        pref_code_name: prefecture.pref_code_name,
        pref_name: prefecture.pref_name,
        pref_kana: prefecture.pref_kana,
        mansion_count: prefecture.mansion_count,
      };
      return prefecturesRecord;
    }),
  );
  return prefecturesData;
};

interface PrefecturesRecord {
  id: number;
  region_id: number;
  region_name: string;
  pref_code_name: string;
  pref_name: string;
  pref_kana: string;
  mansion_count: number;
}
